import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedLicenseTypes} from 'src/openapi/admin/apis/GetSupportedLicenseTypesApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId?: number,
};

export const useSupportedLicenseTypes = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getSupportedLicenseTypes({accountId}, {signal}),
    ), [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
